import { render } from "./RegisterMaskView.vue?vue&type=template&id=2e3967b0&scoped=true"
import script from "./RegisterMaskView.vue?vue&type=script&lang=js"
export * from "./RegisterMaskView.vue?vue&type=script&lang=js"

import "./RegisterMaskView.vue?vue&type=style&index=0&id=2e3967b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e3967b0"]])

export default __exports__